import { Component } from "@angular/core";
import { LeftMenuFacade } from "@youm-front/left-menu/data-access";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html"
})
export class AppComponent {
  constructor(private readonly leftMenuFacade: LeftMenuFacade) {}

  get leftMenuIsOpen$() {
    return this.leftMenuFacade.isOpen$;
  }
}
